import React, { useEffect } from "react";
import { connect } from "react-redux";

import { getCompareMode, getSummaryDimensions, getCurrentFilters, getIsDataDisplayed } from "../../selectors";
import DimensionView from "./views/Dimension";
import Global from "./views/Global";
import {
  changePeriodFromSelect,
  changeSubfilterValues,
  setGainChecked,
  setSummaryDimensions,
  onToggleDataDisplayed
} from "../../actions/stats";
import { selectUserRoleId, selectUserSectorsId } from "../../../../redux/selectors/user";
import { roles } from "../../../../configs/constants";

const PerformanceContainer = ({
  dimensions,
  isGlobalDimension,
  changePeriodFromSelect,
  IsComparingActivate,
  filtersData,
  nbSelectedFilters,
  setGainChecked,
  setSummaryDimensions,
  changeSubfilterValues,
  isTerrain,
  userSectorsIds,
  onToggleDataDisplayed,
  isDataDisplayed
}) => {
  useEffect(() => {
    if (isTerrain && dimensions[0] === "global") {
      setSummaryDimensions(["sector_id"]);
      changeSubfilterValues("sector_id", userSectorsIds);
    }
  }, []);
  return isGlobalDimension && !isTerrain ? (
    <Global />
  ) : (
    <DimensionView
      changePeriodFromSelect={changePeriodFromSelect}
      IsComparingActivate={IsComparingActivate}
      filtersData={filtersData}
      nbSelectedFilters={nbSelectedFilters}
      setGainChecked={setGainChecked}
      onToggleDataDisplayed={onToggleDataDisplayed}
      isDataDisplayed={isDataDisplayed}
    />
  );
};

//REDUX
const mapStateToProps = state => {
  const dimensions = getSummaryDimensions(state);

  let nbSelectedFilters = 0;
  const currentFilters = getCurrentFilters(state);
  const filtersData = currentFilters.data || {};
  for (let key of Object.keys(filtersData)) {
    if (
      key === "client_id" ||
      key === "gain_compare_type" ||
      key === "p_visit_statement" ||
      key === "p1_visit_statement" ||
      key === "p_visit_target" ||
      key === "p1_visit_target"
    )
      continue;
    nbSelectedFilters += 1;
  }
  const userRoleId = selectUserRoleId(state);
  const userSectorsIds = selectUserSectorsId(state);
  return {
    dimensions,
    isGlobalDimension: dimensions && dimensions[0] === "global",
    IsComparingActivate: getCompareMode(state),
    nbSelectedFilters,
    isTerrain: userRoleId === roles.TERRAIN,
    userSectorsIds,
    isDataDisplayed: getIsDataDisplayed(state)
  };
};

export default connect(mapStateToProps, {
  changePeriodFromSelect,
  setGainChecked,
  setSummaryDimensions,
  changeSubfilterValues,
  onToggleDataDisplayed
})(PerformanceContainer);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/Summary.js